
// ---------------
// NOUVEAU FICHIER : src/pages/Compliance.js
// ---------------
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Compliance = () => {
    const [showScrollButton, setShowScrollButton] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollButton(true);
            } else {
                setShowScrollButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1>Engagement de Conformité</h1>
                    <p>Opérer avec intégrité, transparence et dans le respect total des réglementations.</p>
                </div>
            </section>

            <section className="legal-page-container">
                <p>
                    Chez WONYA SOFT S.A, la conformité n'est pas une simple obligation, mais le fondement de la confiance que nous accordent nos clients, nos partenaires et les régulateurs. Nous nous engageons à maintenir les plus hauts standards d'éthique et à respecter scrupuleusement le cadre légal et réglementaire de la République Démocratique du Congo.
                </p>

                <article>
                    <h2>ARTICLE 1 : AGRÉMENT ET SUPERVISION DE LA BANQUE CENTRALE DU CONGO (BCC)</h2>
                    <p>
                        WONYA SOFT S.A opère en tant qu'agrégateur de paiement, éditeur de logiciels et fournisseur de solutions monétiques sous l'agrément et la supervision de la <strong>Banque Centrale du Congo (BCC)</strong>. Cet agrément atteste de la robustesse de nos systèmes, de la sécurité de notre infrastructure et de notre adhésion aux directives prudentielles régissant les services financiers en RDC.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 2 : LUTTE CONTRE LE BLANCHIMENT D'ARGENT ET LE FINANCEMENT DU TERRORISME (LBC-FT)</h2>
                    <p>
                        Nous avons mis en place un programme de conformité LBC-FT rigoureux, conformément aux lois congolaises et aux recommandations internationales. Ce programme inclut :
                    </p>
                    <ul>
                        <li><strong>La politique "Connaître son Client" (KYC - Know Your Customer) :</strong> Nous appliquons des procédures de diligence raisonnable pour vérifier l'identité de nos clients et évaluer les risques associés.</li>
                        <li><strong>La surveillance des transactions :</strong> Nos systèmes sont équipés d'outils de surveillance pour détecter et analyser les transactions inhabituelles ou suspectes.</li>
                        <li><strong>La déclaration aux autorités :</strong> Nous nous engageons à coopérer pleinement avec les autorités compétentes, notamment la <strong>Cellule Nationale des Renseignements Financiers (CENAREF)</strong>, en déclarant toute activité suspecte conformément à la loi.</li>
                        <li><strong>La formation continue :</strong> Nos employés reçoivent une formation régulière sur les enjeux et les obligations en matière de LBC-FT.</li>
                    </ul>
                </article>

                <article>
                    <h2>ARTICLE 3 : PROTECTION DES DONNÉES PERSONNELLES</h2>
                    <p>
                        La protection des données de nos utilisateurs est une priorité absolue. Nous nous conformons à la <strong>Loi n° 20/017 du 25 novembre 2020</strong> relative aux télécommunications et aux technologies de l’information et de la communication. Pour plus de détails sur la manière dont nous collectons, utilisons et protégeons vos données, veuillez consulter notre <Link to="/privacy">Politique de Confidentialité</Link>.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 4 : ÉTHIQUE ET CONDUITE PROFESSIONNELLE</h2>
                    <p>
                        Un code de conduite interne guide l'ensemble de nos collaborateurs pour garantir des pratiques commerciales éthiques, éviter les conflits d'intérêts et promouvoir une culture de l'intégrité à tous les niveaux de l'entreprise.
                    </p>
                </article>

                <article>
                    <h2>ARTICLE 5 : CONTACT</h2>
                    <p>
                        Pour toute question relative à notre programme de conformité, veuillez contacter notre département dédié à l'adresse suivante : <a href="mailto:contact@wonyasoft.com">contact@wonyasoft.com</a>.
                    </p>
                </article>
            </section>

            <style>{`
                /* ==================== PAGE RESPONSIVE ==================== */
                .page-hero {
                    padding: 3rem 1.5rem;
                }

                .page-hero h1 {
                    font-size: clamp(1.5rem, 5vw, 3rem);
                    line-height: 1.3;
                }

                .page-hero p {
                    font-size: clamp(1rem, 3vw, 1.25rem);
                    line-height: 1.6;
                    max-width: 100%;
                }

                .legal-page-container {
                    max-width: 900px;
                    margin: 0 auto;
                    padding: 2rem 1.5rem;
                    line-height: 1.8;
                }

                .legal-page-container > p {
                    font-size: 1.05rem;
                    margin-bottom: 2rem;
                    text-align: justify;
                }

                .legal-page-container article {
                    margin-bottom: 3rem;
                    padding: 1.5rem;
                    background: #f8f9fa;
                    border-radius: 12px;
                    border-left: 4px solid #dc2626;
                }

                .legal-page-container article h2 {
                    font-size: clamp(1.2rem, 4vw, 1.75rem);
                    color: #dc2626;
                    margin-bottom: 1rem;
                    margin-top: 0;
                }

                .legal-page-container article p {
                    font-size: 1rem;
                    margin-bottom: 1rem;
                    line-height: 1.8;
                }

                .legal-page-container article ul {
                    margin: 1rem 0;
                    padding-left: 1.5rem;
                }

                .legal-page-container article li {
                    margin-bottom: 0.75rem;
                    font-size: 1rem;
                    line-height: 1.7;
                }

                .legal-page-container article strong {
                    color: #333;
                    font-weight: 700;
                }

                .legal-page-container article a {
                    color: #dc2626;
                    text-decoration: none;
                    border-bottom: 1px solid #dc2626;
                    transition: color 0.3s ease;
                }

                .legal-page-container article a:hover {
                    color: #991b1b;
                }

                /* ==================== MOBILE RESPONSIF ==================== */
                @media (max-width: 768px) {
                    .legal-page-container {
                        padding: 1.5rem 1rem;
                    }

                    .legal-page-container article {
                        padding: 1.25rem;
                        margin-bottom: 2rem;
                        border-radius: 8px;
                    }

                    .legal-page-container article h2 {
                        font-size: 1.3rem;
                        margin-bottom: 0.75rem;
                    }

                    .legal-page-container article p {
                        font-size: 0.95rem;
                    }

                    .legal-page-container article li {
                        font-size: 0.95rem;
                        margin-bottom: 0.6rem;
                    }
                }

                @media (max-width: 480px) {
                    .page-hero {
                        padding: 2rem 1rem;
                    }

                    .page-hero h1 {
                        font-size: 1.5rem;
                        margin-bottom: 1rem;
                    }

                    .page-hero p {
                        font-size: 0.95rem;
                        line-height: 1.5;
                    }

                    .legal-page-container {
                        padding: 1rem;
                        margin: 0;
                    }

                    .legal-page-container > p {
                        font-size: 0.95rem;
                        text-align: left;
                        margin-bottom: 1.5rem;
                        line-height: 1.7;
                    }

                    .legal-page-container article {
                        padding: 1rem;
                        margin-bottom: 1.5rem;
                        border-left-width: 3px;
                        border-radius: 6px;
                    }

                    .legal-page-container article h2 {
                        font-size: 1.15rem;
                        margin-bottom: 0.75rem;
                        word-break: break-word;
                    }

                    .legal-page-container article p {
                        font-size: 0.9rem;
                        margin-bottom: 0.75rem;
                        line-height: 1.6;
                    }

                    .legal-page-container article ul {
                        padding-left: 1.2rem;
                        margin: 0.75rem 0;
                    }

                    .legal-page-container article li {
                        font-size: 0.9rem;
                        margin-bottom: 0.5rem;
                        line-height: 1.5;
                    }

                    .legal-page-container article strong {
                        display: inline;
                        color: #333;
                    }
                }

                /* ==================== BOUTON SCROLL TO TOP ==================== */
                .scroll-to-top-btn {
                    position: fixed;
                    bottom: 2rem;
                    right: 2rem;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
                    border: none;
                    color: white;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
                    transition: all 0.3s ease;
                    z-index: 999;
                }

                .scroll-to-top-btn:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
                }

                .scroll-to-top-btn:active {
                    transform: translateY(-1px);
                }

                .scroll-to-top-btn svg {
                    width: 24px;
                    height: 24px;
                }

                @media (max-width: 768px) {
                    .scroll-to-top-btn {
                        bottom: 1.5rem;
                        right: 1.5rem;
                        width: 48px;
                        height: 48px;
                    }

                    .scroll-to-top-btn svg {
                        width: 24px;
                        height: 24px;
                    }
                }

                @media (max-width: 480px) {
                    .scroll-to-top-btn {
                        bottom: 1rem;
                        right: 1rem;
                        width: 45px;
                        height: 45px;
                    }

                    .scroll-to-top-btn svg {
                        width: 20px;
                        height: 20px;
                    }
                }
            `}</style>

            {/* Bouton Scroll to Top */}
            {showScrollButton && (
                <button 
                    onClick={scrollToTop} 
                    className="scroll-to-top-btn"
                    title="Remonter en haut"
                    aria-label="Remonter en haut de la page"
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="18 15 12 9 6 15"></polyline>
                    </svg>
                </button>
            )}
        </>
    );
};

export default Compliance;